import { useLocation, useNavigate } from "react-router-dom";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import Sidebar from "../../components/Sidebar";

const BusinessCustomWaiverComingSoon = () => {
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  // 🔐 Auth guard (same as CreateWaiverType)
  if (!business) {
    navigate("/business/login");
    return null;
  }

  const from = location.state?.from;

  const handleBack = () => {
    if (from === "smart-step1") {
      navigate("/business/waiverbuilder/smart/step-1");
    } else if (from === "create-waiver") {
      navigate("/business/waiverbuilder/create");
    } else {
      navigate("/business/waiverbuilder/create");
    }
  };

  return (
    <div className="h-screen flex flex-row bg-background">
      {/* Left Sidebar */}
      <Sidebar />

      {/* Right Content */}
      <div className="flex-1 h-auto overflow-auto py-9 transition">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h1 className="text-3xl font-semibold mb-4">
            Custom Waiver
          </h1>

          <p className="text-foreground mb-10">
            This feature is coming soon. We’re working hard to make it available.
          </p>

          <div className="bg-white rounded-xl shadow-sm p-10 inline-block">
            <p className="text-gray-600 mb-8">
              You’ll soon be able to create a fully custom waiver with complete
              control over structure and legal language.
            </p>

            <button
              onClick={handleBack}
              className="inline-flex items-center gap-2 bg-black text-white py-3 px-6 rounded-full hover:bg-gray-800 transition"
            >
              ← Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCustomWaiverComingSoon;